module.exports = __webpack_public_path__ + "static/media/map.bab2b509.png";